import { createElement } from 'react';

interface WeaveRadioButtonGroupProps {
	name: string;
	children: React.ReactNode;
}

export function WeaveRadioButtonGroup({ name, children }: WeaveRadioButtonGroupProps) {
	return createElement('weave-radio-button-group', { name }, children);
}
